"use client";

import styles from "../../Supplier Ratings/css/supplierRatings.module.css";
import Navbar from "../../../../components/navbar";
import Footer from "../../../../components/footer";
import RatingsModalContainer from "../components/RatingsModalContainer";

export default function SupplierRatings() {
  return (
    <div className={styles.wrapper}>
      <Navbar />
      <div className={styles.dashboardLayout}>
        <main className={styles.main}>
          <div className={styles.container}>
            <RatingsModalContainer />
          </div>
        </main>
      </div>
      <div className={styles.footerWrapper}>
        <Footer />
      </div>
    </div>
  );
}
